export default {
  env: "prod",
  partialURL: "https://edwhat.com/core/api/"
};
